






















































































































































































































































































































































import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { RegraPorEstado } from '@/models/fiscal/RegraPorEstado'
import SeletorDeEstado from '@/components/ui/SeletorDeEstado.vue'
import CamposDeImposto from './shareds/CamposDeImposto.vue'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import CamposDeTipoDeOperacaoFiscal from './shareds/CamposDeTipoDeOperacaoFiscal.vue'
import { CodigoEDescricao } from '@/models'
import type { CST, CstComOperacao, RegimeFiscal } from '@/models'
import {
	FindRegraPorEstadoUseCase,
	FindICMSUseCase,
	FindPISUseCase,
	FindCOFINSUseCase,
	SaveRegraPorEstadoUseCase,
	FindIBSUseCase,
} from '@/usecases'
import axios, { CancelTokenSource } from 'axios'
import { sortConverter } from '@/shareds/paginacao'
import { DataOptions } from 'vuetify'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CamposDeImpostoIBSCBS from './shareds/CamposDeImpostoIBSCBS.vue'
import SeletorDeCst from '@/components/fiscal/SeletorDeCst.vue'
import SeletorDeClassificacaoTributaria from '@/components/fiscal/SeletorDeClassificacaoTributaria.vue'

@Component({
	components: {
		SeletorDeEstado,
		CamposDeImposto,
		CamposDeImpostoIBSCBS,
		CampoDePercentual,
		CampoDecimal,
		CamposDeTipoDeOperacaoFiscal,
		SeletorDeCst,
		SeletorDeClassificacaoTributaria,
	},
})
export default class TelaDeRegraPorEstado extends Vue {
	@Ref() campoDeEstado!: SeletorDeEstado
	@Prop({ type: String}) ufOrigem!: string
	@Prop({ type: String}) idRegraAplicacao!: string
	@Prop({ type: String}) idRegraImposto!: string
	@Prop({ type: String}) regimeFiscal!: RegimeFiscal

	findRegraPorEstadoUseCase = new FindRegraPorEstadoUseCase()
	saveRegraPorEstadoUseCase = new SaveRegraPorEstadoUseCase()

	icmsDefault: CodigoEDescricao | null = null
	pisDefault: CodigoEDescricao | null = null
	cofinsDefault: CodigoEDescricao | null = null
	ibscbsDefault: CodigoEDescricao | null = null

	tab = null

	quantidadeDeEstados = 0

	cancelToken: CancelTokenSource | null = null
	regrasPorEstado: RegraPorEstado[] = []

	regraPorEstado: RegraPorEstado | null = null

	loadingCopia = false

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 50,
		sortBy: [ 'ufDestino' ],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	salvando = false

	mostra = false
	icmsst = 'ICMS ST'
	selection = 1
	
	estadoSelecionadoId: string | null = null

	get cstIBSCBS() {
		const regraAtual = this.tab !== null && this.tab !== undefined 
			? this.regrasPorEstado[this.tab] 
			: this.regraPorEstado
		return regraAtual?.impostos.find(i => i.tipoDeImposto === 'IBS')?.csts[0].cst || null
	}

	set cstIBSCBS(cst: CST | null) {
		const regra = this.tab !== null && this.tab !== undefined 
			? this.regrasPorEstado[this.tab] 
			: this.regraPorEstado
		if (!regra) return
		const impostoIBS = Array.isArray(regra.impostos)
			? regra.impostos.find(i => i.tipoDeImposto === 'IBS')
			: undefined

		const impostoCBS = Array.isArray(regra.impostos)
			? regra.impostos.find(i => i.tipoDeImposto === 'CBS')
			: undefined
			
		if (!impostoIBS || !Array.isArray(impostoIBS.csts) || !impostoIBS.csts[0]) return
		if (!impostoCBS || !Array.isArray(impostoCBS.csts) || !impostoCBS.csts[0]) return

		if (cst !== null) {
			impostoIBS.csts[0].cst = cst
			impostoCBS.csts[0].cst = cst
		}
	}

	created() {
		this.carregar()
	}

	async carregar() {
		this.icmsDefault = (await new FindICMSUseCase().find({ codigo: '00' })).content[0]
		this.pisDefault = (await new FindPISUseCase().find({ codigo: '06' })).content[0]
		this.cofinsDefault = (await new FindCOFINSUseCase().find({ codigo: '06' })).content[0]
		this.ibscbsDefault = (await new FindIBSUseCase().find({ codigo: '00' })).content[0]

		if (this.cancelToken) this.cancelToken.cancel()
		this.cancelToken = axios.CancelToken.source()
		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}
		const sorted = sortConverter(this.paginacao)

		const itensPaginados = await this.findRegraPorEstadoUseCase.find(this.idRegraAplicacao, this.ufOrigem, {
			sort: [...sorted],
			page: this.paginacao.page - 1 || 0,
			size: this.paginacao.itemsPerPage,
		}, axiosConfig)

		this.regrasPorEstado = itensPaginados.content
		this.quantidadeDeEstados = itensPaginados.totalElements

		if (this.regrasPorEstado.length > 0) {
			this.regraPorEstado = this.regrasPorEstado[0]

			if (Object.keys({ ...this.regraPorEstado.impostos }).length === 0) {
				this.regraPorEstado = this.preencherRegraPorEstado(this.regraPorEstado);
			}
		}

		this.ordenarImpostos()
	}

	get estadosACopiar(): RegraPorEstado[] {
		return this.regrasPorEstado
	}

	podeInformarDiferimentoDeICMS(regra: RegraPorEstado) {
		return this.getCstICMS(regra) === '51'
	}

	podeInformarPercentualReducaoBCICMS(regra: RegraPorEstado) {
		return this.getCstICMS(regra) === '20'
	}

	podeInformarPercentualReducaoIBSCBS(regra: RegraPorEstado) {
		return this.getCstIBSCBS(regra) === '200'
	}

	getCstIBSCBS(regra: RegraPorEstado) {
		if(!regra) return '00'
		if(!regra.impostos) return '00'

		let impostoDeIBS

		if (Array.isArray(regra.impostos)) {
			impostoDeIBS = regra.impostos.find(imposto => imposto.tipoDeImposto === 'IBS')
		} else {
			return '00'
		}

		if (!impostoDeIBS || !impostoDeIBS.csts) return '00'

		const cstIBSFiltrado = impostoDeIBS.csts.filter(cst => cst.operacao === 'SAIDA');

		if (cstIBSFiltrado.length > 0) {
			return cstIBSFiltrado[0].cst.codigo
		}

		return '00'
	}

	getCstICMS(regra: RegraPorEstado) {
		if(!regra) return '00'
		if(!regra.impostos) return '00'

		let impostoDeICMS

		if (Array.isArray(regra.impostos)) {
			impostoDeICMS = regra.impostos.find(imposto => imposto.tipoDeImposto === 'ICMS')
		} else {
			return '00'
		}

		if (!impostoDeICMS || !impostoDeICMS.csts) return '00'

		const cstICMSFiltrado = impostoDeICMS.csts.filter(cst => cst.operacao === 'SAIDA');

		if (cstICMSFiltrado.length > 0) {
			return cstICMSFiltrado[0].cst.codigo
		}

		return '00'
	}

	async copiarParaSelecionado(regraPorEstadoAba: RegraPorEstado) {
		try {
			this.loadingCopia = true
			if (regraPorEstadoAba.id && this.estadoSelecionadoId) {
				const regraCopiada = await this.saveRegraPorEstadoUseCase.copiar(regraPorEstadoAba.id, this.estadoSelecionadoId)

				const indice = this.regrasPorEstado.findIndex(r => r.id === this.estadoSelecionadoId)

				this.regrasPorEstado.splice(indice, 1, regraCopiada)

				AlertModule.setSuccess(`Regra copiada com sucesso`)
			} else {
				AlertModule.setError('Nenhuma regra selecionada, verifique!')
			}
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.loadingCopia = false
		}
	}

	esconder() {
		this.mostra = false
	}

	voltarParaTelaAnterior() {
		this.$router.back();
	}

	ordenarImpostos() {
		this.regrasPorEstado = this.regrasPorEstado.map((regra: RegraPorEstado)  => {
			if (!regra) return regra

			if (Object.keys({ ...regra.impostos }).length === 0) {
				regra = this.preencherRegraPorEstado(regra);
			}

			return regra
		})
	}
	
	removeEspacosEmBranco(codigo: string | null): string {
		return codigo ? codigo.replace(/\s+/g, '') : ''
	}

	async salvar() {
		try {
			this.salvando = true

			for (let i = 0; i < this.regrasPorEstado.length; i++) {
				if (this.regrasPorEstado[i].percentualFCP === null || this.regrasPorEstado[i].percentualFCP?.toString() === '') {
					this.regrasPorEstado[i].percentualFCP = 0;
				}
			}
			
			this.regrasPorEstado = await this.saveRegraPorEstadoUseCase.save(this.idRegraImposto, this.idRegraAplicacao, this.regrasPorEstado)
			AlertModule.setSuccess(`Regras do estado origem ${this.regraPorEstado?.ufOrigem} foram salvas com sucesso.`)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
	
	preencherRegraPorEstado(regraPorEstadoNaoPreenchida: RegraPorEstado): RegraPorEstado {
		const cstIBSCBS = {
			id: '',
			operacao: 'SAIDA',
			cst:  {
				id: this.ibscbsDefault?.id,
				codigo: this.ibscbsDefault?.codigo || '',
				descricao: this.ibscbsDefault?.descricao || '',
				tipo: 'IBS',
			},
		} as CstComOperacao

		return {
			id: regraPorEstadoNaoPreenchida.id,
			ufDestino: regraPorEstadoNaoPreenchida != null ? regraPorEstadoNaoPreenchida.ufDestino : '',
			ufOrigem: this.ufOrigem,
			tiposDeOperacoesFiscais: regraPorEstadoNaoPreenchida.tiposDeOperacoesFiscais || [],
			impostos: [
				{
					tipoDeImposto: 'ICMS',
					aliquota: 0,
					csts: [
						{
							id: '',
							operacao: 'SAIDA',
							cst:  {
								id: this.icmsDefault?.id,
								codigo: this.icmsDefault?.codigo || '',
								descricao: this.icmsDefault?.descricao || '',
								tipo: 'ICMS',
							},
						},
					],
				},
				{
					tipoDeImposto: 'PIS',
					aliquota: 0,
					csts: [
						{
							id: '',
							operacao: 'SAIDA',
							cst:  {
								id: this.pisDefault?.id,
								codigo: this.pisDefault?.codigo || '',
								descricao: this.pisDefault?.descricao || '',
								tipo: 'PIS',
							},
						},
						{
							id: '',
							operacao: 'DEVOLUCAO',
							cst:  {
								id: this.pisDefault?.id,
								codigo: this.pisDefault?.codigo || '',
								descricao: this.pisDefault?.descricao || '',
								tipo: 'PIS',
							},
						},
					],
				},
				{
					tipoDeImposto: 'COFINS',
					aliquota: 0,
					csts: [
						{
							id: '',
							operacao: 'SAIDA',
							cst:  {
								id: this.cofinsDefault?.id,
								codigo: this.cofinsDefault?.codigo || '',
								descricao: this.cofinsDefault?.descricao || '',
								tipo: 'COFINS',
							},
						},
						{
							id: '',
							operacao: 'DEVOLUCAO',
							cst:  {
								id: this.cofinsDefault?.id,
								codigo: this.cofinsDefault?.codigo || '',
								descricao: this.cofinsDefault?.descricao || '',
								tipo: 'COFINS',
							},
						},
					],
				},
				{
					tipoDeImposto: 'IBS',
					aliquota: 0,
					csts: [
						cstIBSCBS,
					],
				},
				{
					tipoDeImposto: 'CBS',
					aliquota: 0,
					csts: [
						cstIBSCBS,
					],
				},
			],
			percentualFCP: regraPorEstadoNaoPreenchida.percentualFCP || 0,
			percentualMVA: regraPorEstadoNaoPreenchida.percentualMVA,
			regraAtiva: regraPorEstadoNaoPreenchida.regraAtiva,
			reduzIcms: regraPorEstadoNaoPreenchida.reduzIcms,
			incluirFrete:  regraPorEstadoNaoPreenchida.incluirFrete,
			utilizarCstPisCofinsOrigem: regraPorEstadoNaoPreenchida.utilizarCstPisCofinsOrigem,
			codigosDeBeneficio: regraPorEstadoNaoPreenchida.codigosDeBeneficio,
			codigoCreditoPresumido: regraPorEstadoNaoPreenchida.codigoCreditoPresumido,
			aliquotaCreditoPresumido: regraPorEstadoNaoPreenchida.aliquotaCreditoPresumido,
			mensagem: regraPorEstadoNaoPreenchida.mensagem,
			reduzDifal: regraPorEstadoNaoPreenchida.reduzDifal,
			aliquotaDifICMS: regraPorEstadoNaoPreenchida.aliquotaDifICMS,
			codigoClassificacaoTributaria: regraPorEstadoNaoPreenchida.codigoClassificacaoTributaria,
			reduzImpostosBcIBSCBS: regraPorEstadoNaoPreenchida.reduzImpostosBcIBSCBS,
			utilizarImpostosIBSCBS: regraPorEstadoNaoPreenchida.utilizarImpostosIBSCBS,
			percentualReducaoBcIcms: regraPorEstadoNaoPreenchida.percentualReducaoBcIcms,
			percentualReducaoIBS: regraPorEstadoNaoPreenchida.percentualReducaoIBS,
			percentualReducaoCBS: regraPorEstadoNaoPreenchida.percentualReducaoCBS,
		}
	}
}

